import { render, staticRenderFns } from "./AddIns.vue?vue&type=template&id=f9eff95a&scoped=true&"
import script from "./AddIns.vue?vue&type=script&lang=js&"
export * from "./AddIns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9eff95a",
  null
  
)

export default component.exports